import { render } from "./PharmaShipping.vue?vue&type=template&id=20265286&scoped=true&ts=true"
import script from "./PharmaShipping.vue?vue&type=script&lang=ts"
export * from "./PharmaShipping.vue?vue&type=script&lang=ts"

import "./PharmaShipping.vue?vue&type=style&index=0&id=20265286&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20265286"]])

export default __exports__